import React from 'react';
import {useLocale} from "../contexts/LocaleContext";
import {NativeSelect} from "@mui/material";
import i18n from "i18next";

interface Language {
    code: string;
    name: string;
    flag: string;
}

const LanguageSelector: React.FC = () => {
    const { locale, setLocale } = useLocale();

    const languages: Language[] = [
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'es', name: 'Español', flag: '🇪🇸' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        //{ code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    ];

    const handleLocaleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setLocale(event.target.value);
        i18n.changeLanguage(event.target.value);
    };

    return (
        <NativeSelect
            defaultValue={locale}
            onChange={handleLocaleChange}>
            {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                    {lang.flag} {lang.name}
                </option>
            ))}
        </NativeSelect>
    );
};

export default LanguageSelector;